import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

/* Utilities */
import { randomString } from 'util/string'

/* Styles */
import './textinput.css'

import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'


/* Single Playlist List Item */
export default class TextInput extends Component {

    constructor(props) {
        super(props)
        this.state = { edit: false, value: props.value }
    }

    componentWillReceiveProps(nextProps) {
        if( this.props.value === nextProps.value ) return
        this.setState({ value: nextProps.value })
    }

    onKeyDown(e) {
        if(!this.state.edit) return // ignore all events while not in edit mode
        switch (e.keyCode) {
            case 13: // enter
                e.preventDefault()
                e.stopPropagation()
                this.onSave()
                break
            case 27: // esc
                e.preventDefault()
                e.stopPropagation()
                this.onCancel()
                break
        }
    }

    onSave() {
        if (!this.isValid()) return
        if (this.props.onSave) this.props.onSave(this.state.value)
        this.inputElement.blur()
    }

    onReset() {
        if (this.props.onReset) this.props.onReset()
        this.setState({ value: this.props.defaultValue || "" })
    }

    onUndo() {
        if (this.props.onUndo) this.props.onUndo()
        this.setState({ value: this.props.value })
        this.inputElement.blur()
    }

    onCancel() {
        if (this.props.onCancel) this.props.onCancel()
        this.inputElement.blur()
    }

    onFocus() {
        this.setState({ edit: true })
        if (this.props.onEdit) this.props.onEdit()
    }

    onBlur() {
        this.setState({ edit: false })
    }

    onChange(e) {
        if (!this.state.edit) return // only during edit state
        this.setState({ value: e.target.value })
        if (this.props.onChange) {
            e.stopPropagation()
            this.props.onChange(e)
        }
    }

    onInput(e) {
        if (!this.state.edit) return // only during edit state
        this.setState({ value: e.target.value })
        if (this.props.onInput) {
            this.props.onInput(e)
        }
    }

    onClick(e) {
        if (!this.state.edit) e.stopPropagation()
        e.preventDefault()
    }

    onDragStart(e) {
        if (!this.state.edit) return // only during edit state
        e.stopPropagation()
        e.preventDefault()
    }

    onDragOver(e) {
        if (!this.state.edit) return // only during edit state
        //e.stopPropagation()
        e.dataTransfer.dropEffect='none'
        e.preventDefault()
    }

    onDragEnter(e) {
        if (!this.state.edit) return // only during edit state
        //e.stopPropagation()
        e.dataTransfer.dropEffect='none'
        e.preventDefault()
    }

    onDrop(e) {
        e.dataTransfer.dropEffect='none'
        e.preventDefault()
        if (!this.state.edit) return // only during edit state
        //e.stopPropagation()
    }

    onMouseDown(e) {
        e.preventDefault()
    }

    onButtonMouseDown(e) {
        // stop focus loss
        e.stopPropagation()
        e.preventDefault()
    }

    onSaveButtonClick(e) {
        e.stopPropagation()
        e.preventDefault()
        this.onSave()
    }

    onResetButtonClick(e) {
        e.stopPropagation()
        e.preventDefault()
        this.onReset()
    }

    onUndoButtonClick(e) {
        e.stopPropagation()
        e.preventDefault()
        this.onUndo()
    }

    hasChanged() {
        return this.state.value !== this.props.value
    }

    isValid() {
        const { validate } = this.props
        const { value } = this.state
        return !validate || validate(value)
    }

    getClassName() {
        const {
            className
        } = this.props
        let classNameArr = (className || "").split(' ')
        classNameArr.push('text-input', 'widget')
        if (this.hasChanged()) classNameArr.push('changed')
        return  classNameArr.join(' ')
    }


    getInputClassName() {
        if (!this.isValid()) return 'invalid'
        return null
    }

    renderSaveButton() {
        const {
            edit
        } = this.state
        const {
            saveTitle
        } = this.props
        if (edit && this.hasChanged() && this.isValid() &&  !this.props.noSave) {
            return (
                <button
                    tabIndex="-1"
                    onClick={ this.onSaveButtonClick.bind(this) }
                    onMouseDown={ this.onButtonMouseDown.bind(this) }
                    title={ saveTitle }
                >
                    <Icon icon={ ICON.SAVE } size={ 24 }/>
                </button>
            )
        }
    }

    renderUndoButton() {
        const {
            edit
        } = this.state
        const {
            resetTitle
        } = this.props
        if (edit && this.hasChanged() &&  !this.props.noUndo) {
            return (
                <button
                    tabIndex="-1"
                    onClick={ this.onUndoButtonClick.bind(this) }
                    onMouseDown={ this.onButtonMouseDown.bind(this) }
                    title={ resetTitle }
                >
                    <Icon icon={ ICON.UNDO } size={ 24 }/>
                </button>
            )
        }
    }

    renderResetButton() {
        const {
            edit,
        } = this.state
        const {
            clearTitle
        } = this.props
        if (edit && !this.props.noReset) {
            return (
                <button
                    tabIndex="-1"
                    onClick={ this.onResetButtonClick.bind(this) }
                    onMouseDown={ this.onButtonMouseDown.bind(this) }
                    title={ clearTitle }
                >
                    <Icon icon={ ICON.DELETETEXT } size={ 24 }/>
                </button>
            )
        }
    }

    renderLabel() {
        const { label, labelWidth } = this.props
        if (!label) return null
        var style = (!labelWidth)?{}:{width: labelWidth+"px"}
        return (
            <div className="inputLabel" style={ style }>{ label }</div>
        )
    }

    renderInputToolbar() {
        const {
            edit
        } = this.state

        return (
            <div className="toolbar">
                { this.renderSaveButton() }
                { this.renderUndoButton() }
                { this.renderResetButton() }
            </div>
        )
    }

    getInputType() {
        return this.props.password?"password":"text"
    }

    render() {
        const {
            title,
            placeholder,
            labelWidth,
            disabled
        } = this.props
        const {
            edit,
            value
        } = this.state
        var style = (!labelWidth)?{}:{minWidth: (110+labelWidth).toString() + "px"}
        return (
            <div
                draggable={ !edit }
                className={ this.getClassName() }
                style={ style }
            >
                <div className="toolbar-wrapper">
                    { this.renderLabel() }
                    <input
                        type={ this.getInputType() }
                        draggable={ !edit }
                        disabled={ disabled }
                        title={ title }
                        value={ value }
                        placeholder={ placeholder }
                        ref={ (elem) => { this.inputElement = elem } }
                        className={ this.getInputClassName() }
                        onDragStart={ this.onDragStart.bind(this) }
                        onDrop={ this.onDrop.bind(this) }
                        onDragOver={ this.onDragOver.bind(this) }
                        onDragEnter={ this.onDragEnter.bind(this) }
                        onClick={ this.onClick.bind(this)}
                        onKeyDown={ this.onKeyDown.bind(this)}
                        onChange={ this.onChange.bind(this) }
                        onInput={ this.onInput.bind(this) }
                        onFocus={ this.onFocus.bind(this) }
                        onBlur={ this.onBlur.bind(this) }
                    />
                    { this.renderInputToolbar() }
                </div>
            </div>
        )
    }
}

TextInput.propTypes = {
    placeholder: PropTypes.string,
    label: PropTypes.string,
    labelWidth: PropTypes.number,
    title: PropTypes.string,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    onInput: PropTypes.func,
    onCancel: PropTypes.func,
    onReset: PropTypes.func,
    onUndo: PropTypes.func,
    onSave: PropTypes.func,
    onEdit: PropTypes.func,
    validate: PropTypes.func,
    noSave: PropTypes.bool,
    noReset: PropTypes.bool,
    noUndo: PropTypes.bool,
    password: PropTypes.bool,
    disabled: PropTypes.bool,
    saveTitle: PropTypes.string,
    resetTitle: PropTypes.string,
    clearTitle: PropTypes.string,

}



// WEBPACK FOOTER //
// ./src/app/widget/text-input/index.jsx